import React, { Component } from "react";
import Select from "@material-ui/core/Select";
import InputBase from "@material-ui/core/InputBase";
import MenuItem from "@material-ui/core/MenuItem";

export default class CustomizedSelect extends Component {
  render() {
    const { nolabel } = this.props;
    return (
      <div
        style={{
          width: this.props.nomineeStyle ? "30%" : "100%",
        }}
      >
        <div
          style={{ display: nolabel ? "none" : "flex", alignItems: "center" }}
          className="select-custom"
        >
          <div className="input-name">
            {this.props.name}
            {this.props.isMandatory && <span className="mandatory">*</span>}
          </div>
          {this.props.uptext && (
            <div
              className="input-name"
              style={{
                fontSize: 15,
                marginLeft: 10,
                color: "red",
              }}
            >
              {this.props.uptext}
            </div>
          )}
        </div>
        <Select
          value={this.props.value}
          onChange={this.props.handleChange}
          displayEmpty
          disabled={this.props.disabled}
          inputRef={this.props.inputRef}
          input={
            <InputBase
              name={this.props.name}
              id={this.props.id}
              style={{
                border: "1px solid #a6a6a6",
                borderColor: this.props.isError
                  ? "red"
                  : this.props.borderColor
                  ? this.props.borderColor
                  : "#a6a6a6",
                minHeight: 50,
                borderRadius: 5,
                width: this.props.width || "100%",
                padding: "7px 15px",
                margin: "0px 0px 0px",
              }}
            />
          }
        >
          {!!this.props.placeholder && (
            <MenuItem value="" disabled>
              <em>{this.props.placeholder}</em>
            </MenuItem>
          )}
          {this.props.children}
        </Select>
        {!!this.props.isError && (
          <div
            className="input-name"
            style={{ color: "red", fontFamily: "Rubik-Italic" }}
          >
            {this.props.errorMessage}
          </div>
        )}
      </div>
    );
  }
}
